<script setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import api from "../axios.js";
const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const { t } = useI18n();
const router = useRouter();

const newPassword = ref("");
const confirmPassword = ref("");
const valid = ref(false);
const loading = ref(false);
const error = ref("");
const success = ref("");

const changePassword = async () => {
  error.value = "";
  success.value = "";

  try {
    loading.value = true;

    const token = localStorage.getItem("token");
    await api.put(
      `${apiBaseUrl}/auth/change-password`,
      { newPassword: newPassword.value },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    success.value = t("success.changePassword");
    newPassword.value = "";
    confirmPassword.value = "";

    // Vänta 1,5 sek innan redirect
    setTimeout(() => {
      router.back();
    }, 1500);
  } catch (err) {
    error.value = err.response?.data?.message || t("errors.changePassword");
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <v-container class="py-10 mt-16" max-width="500px">
    <h1 class="text-h5 mb-6">{{ t("login.changePassword") }}</h1>

    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="newPassword"
        :label="t('login.newPassword')"
        type="password"
        :rules="[
          (v) => !!v || t('validation.required'),
          (v) => v.length >= 5 || t('login.passwordLength'),
        ]"
        prepend-inner-icon="mdi-lock"
      />

      <v-text-field
        v-model="confirmPassword"
        :label="t('login.confirmPassword')"
        type="password"
        :rules="[
          (v) => !!v || t('validation.required'),
          (v) => v === newPassword || t('login.passwordMatch'),
        ]"
        prepend-inner-icon="mdi-lock-check"
      />

      <v-btn
        :disabled="!valid || loading"
        color="primary"
        class="mt-4"
        @click="changePassword"
      >
        {{ loading ? t("loading") : t("login.changePassword") }}
      </v-btn>

      <v-alert v-if="error" type="error" class="mt-4" dense>
        {{ error }}
      </v-alert>

      <v-alert v-if="success" type="success" class="mt-4" dense>
        {{ success }}
      </v-alert>
    </v-form>
  </v-container>
</template>
